import React from 'react';
import HideableSection from 'react-scale/corp/components/UI/HideableSection';

import { WithCopy } from '@scale/frontend-lib/sensor-fusion';
import { Table, TableColumn, Typography } from '@scale/scaleui';
import { ISensorFusionSubstageInstanceLookupDto } from '@scale/sensor-fusion-shared';

type SubstageInstanceResponsePanelProps = {
  substageInstance: ISensorFusionSubstageInstanceLookupDto;
};

const RESPONSE_TABLE_COLUMNS: TableColumn[] = [{ header: 'Response URL', id: 'url' }];

const SubstageInstanceResponsePanel = ({
  substageInstance,
}: SubstageInstanceResponsePanelProps) => {
  const responseTableData = substageInstance.responses.map(response => ({
    url: (
      <WithCopy copyText={response.url}>
        <a className="text-info-700" href={response.url}>
          {response.url}
        </a>
      </WithCopy>
    ),
  }));

  return (
    <HideableSection name="Responses">
      {responseTableData.length === 0 ? (
        <Typography.Paragraph2>No Responses</Typography.Paragraph2>
      ) : (
        <Table
          columns={RESPONSE_TABLE_COLUMNS}
          data={responseTableData}
          divideRows
          manualPagination
        />
      )}
    </HideableSection>
  );
};

export default SubstageInstanceResponsePanel;
